//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'DataScreen',
    props: {
        scannedData: {
            type: Object,
            required: true,
            default: () => ({
                // barcode: '4713095472527',
                // productCode: '89H20565160010',
                // productName: '拭拭樂嬰兒柔濕巾(心花漾)80P 24包',
                // upperLimit: '1234',
                // lowerLimit: '1234'
            })
        }
    }
}
